import { FaCheck } from "react-icons/fa";
import "./inputCheckbox.scss";

const InputCheckbox = ({
    checked = false,
    onChange,
    label,
    required = false,
}) => {
    const handleChange = (e) => {
        if (onChange) {
            onChange(e);
        }
    };

    return (
        <label className="checkbox-container">
            <input
                type="checkbox"
                className="checkbox-input"
                checked={checked}
                onChange={handleChange}
            />
            <div className="checkbox-box">
                {checked && (
                    <span className="checkbox-checkmark">
                        <FaCheck />
                    </span>
                )}
            </div>
            {label && (
                <span className="checkbox-text">
                    {label}
                    {required && <span className="checkbox-required">*</span>}
                </span>
            )}
        </label>
    );
};

export default InputCheckbox;
